import votingService from './votingService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8002/api/v1';

export interface QotdResults {
  total_votes: number;
  positive_votes: number;
  negative_votes: number;
  positive_percentage: number;
  negative_percentage: number;
  has_voted: boolean;
  user_vote?: {
    is_positive: boolean;
    created_at?: string | null;
  } | null;
}

export interface ActiveQotdResponse {
  id: number;
  date: string;
  key: string;
  question_text: string;
  option_negative_text: string;
  option_positive_text: string;
  results: QotdResults;
}

class QotdService {
  private headers() {
    return {
      'Content-Type': 'application/json',
      'X-Session-ID': votingService.getCurrentSessionId() || '',
    };
  }

  async getActive(languageCode: string): Promise<ActiveQotdResponse> {
    const response = await fetch(`${API_BASE_URL}/qotd/active?language_code=${encodeURIComponent(languageCode)}`, {
      method: 'GET',
      headers: this.headers(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  async getResults(languageCode: string, date?: string): Promise<ActiveQotdResponse> {
    const params = new URLSearchParams({ language_code: languageCode });
    if (date) params.set('date', date);
    const response = await fetch(`${API_BASE_URL}/qotd/results?${params.toString()}`, {
      method: 'GET',
      headers: this.headers(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  async vote(input: { latitude: number; longitude: number; isPositive: boolean }) {
    const response = await fetch(`${API_BASE_URL}/qotd/vote`, {
      method: 'POST',
      headers: this.headers(),
      body: JSON.stringify({
        latitude: input.latitude,
        longitude: input.longitude,
        is_positive: input.isPositive,
      }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }
}

const qotdService = new QotdService();
export default qotdService;
